import React from 'react';
import { TrendingUp, TrendingDown } from 'lucide-react';
import Card from '../common/Card';
import { formatNumber, formatCurrency } from '../../utils/helpers';

const KPICard = ({ title, value, icon: Icon, trend, trendValue, format = 'number', color = 'primary' }) => {
  const formattedValue = format === 'currency' ? formatCurrency(value) : formatNumber(value);
  const isPositive = trendValue >= 0;

  const colorClasses = {
    primary: { bg: 'bg-primary-50', icon: 'text-primary-600' },
    success: { bg: 'bg-success-50', icon: 'text-success-600' },
    warning: { bg: 'bg-warning-50', icon: 'text-warning-600' },
    danger: { bg: 'bg-danger-50', icon: 'text-danger-600' },
    secondary: { bg: 'bg-primary-50', icon: 'text-primary-600' },
    info: { bg: 'bg-info-50', icon: 'text-info-600' },
  };

  const colors = colorClasses[color] || colorClasses.primary;

  return (
    <Card>
      <div className="flex items-start justify-between">
        <div className="flex-1">
          <p className="text-sm font-medium text-gray-500 mb-1">{title}</p>
          <p className="text-2xl font-bold text-gray-900 mb-2">{formattedValue}</p>
          {trend && (
            <div className="flex items-center space-x-1.5">
              <div className={`flex items-center space-x-1 text-sm ${isPositive ? 'text-success-600' : 'text-danger-600'}`}>
                {isPositive ? (
                  <TrendingUp className="w-4 h-4" />
                ) : (
                  <TrendingDown className="w-4 h-4" />
                )}
                <span className="font-medium">
                  {isPositive ? '+' : ''}{Math.abs(trendValue).toFixed(1)}%
                </span>
              </div>
              <span className="text-xs text-gray-400">vs mes anterior</span>
            </div>
          )}
        </div>
        <div className={`w-12 h-12 ${colors.bg} rounded-lg flex items-center justify-center`}>
          <Icon className={`w-6 h-6 ${colors.icon}`} />
        </div>
      </div>
    </Card>
  );
};

export default KPICard;
